import { getColumnOrder } from '../../../components/v2/table-settings-button/utils/getColumnOrder'

export const assigneeColumnsVersionKey = '/claims-works:assignee-columns-version'

export const addEngineersColumn = (settings: any) => {
  const order = getColumnOrder(settings)
  const responsibleIndex = order.indexOf('responsible_name')
  if (responsibleIndex === -1 || order.includes('engineers_name')) return settings

  const nextOrder = [...order]
  nextOrder.splice(responsibleIndex + 1, 0, 'engineers_name')
  return Array.isArray(settings) ? nextOrder : { ...settings, order: nextOrder }
}
